import moment from 'moment'
import React from 'react'

export default function Message({user, message}) {
    const meIsSender = user._id === message.sender._id;
    return (
        <>
            {(!meIsSender && !message?.isAnnouncement) && <div className="flex py-0 w-full mt-3 pr-14">
                <div className="bg-blue-300 text-gray-900 rounded-t-lg rounded-br-lg min-w-fit py-2 px-2">
                    <p className="mb-0 text-xs">
                    {message?.message}
                    </p>
                    <span className="text-xs text-gray-600">
                        <span className="font-semibold">{message?.sender?.name}</span> - {moment(message.createdAt).fromNow()}
                    </span>
                </div>
            </div>}

           {message.isAnnouncement && <div className="py-0 w-full mt-3">
                <div className="text-gray-600 w-full rounded-t-lg border-2 text-cneter  rounded-bl-lg py-1 px-2">
                    <p className="mb-1 text-xs text-center">
                        {message?.message}  - {moment(message.createdAt).fromNow()}
                    </p>
                </div>
            </div>}

            {(meIsSender && !message?.isAnnouncement) && <div className="flex py-0 w-full m-2 mb-0 justify-end pl-14">
                <div className="bg-gray-200 min-w-fit text-right rounded-t-lg rounded-bl-lg py-2 px-2">
                    <p className="text-xs">
                        {message?.message}
                    </p>
                    <span className="text-xs text-gray-600">
                        <span className="font-semibold">{message?.sender?.name}</span> - {moment(message.createdAt).fromNow()}
                    </span>
                </div>
            </div>}
        </>
    )
}
